export const GET_PROGRAM_STATUS_HISTORY = "GET_PROGRAM_STATUS_HISTORY";
export const START_LOADING_PROGRAM_STATUS_HISTORY = "START_LOADING_PROGRAM_STATUS_HISTORY";
export const STOP_LOADIND_PROGRAM_STATUS_HISTORY = "STOP_LOADING_PROGRAM_STATUS_HISTORY";
export const ERROR_LOADING_PROGRAM_STATUS_HISTORY = "ERROR_LOADING_PROGRAM_STATUS_HISTORY";
